module.exports = __webpack_public_path__ + "img/icon_tips.50df035b.svg";